export enum StatisticsIndicatorType {
    PLAYS = "plays",
    VIEWS = "views",
}
